class DependencyController {
    
    constructor() {
        this.dependentSections = $('.dependent-section');
        this.dependentSections.each(function(i, section){
            this.initDependentSection($(section));
        }.bind(this));
    };

    initDependentSection = function (section) {
        let animateType = section.attr('data-animate-type');

        let dependentOnCheckbox = section.attr('data-dependent-on-checkbox');
        if (dependentOnCheckbox !== undefined) {
            let dependentOn = $(dependentOnCheckbox);
            section.showAnimatedIf(dependentOn.is(':checked'), animateType);

            dependentOn.change(function () {
                section.showAnimatedIf(dependentOn.is(':checked'), animateType);
            });
        }
        let dependentOnCheckboxOff = section.attr('data-dependent-on-checkbox-off');
        if (dependentOnCheckboxOff !== undefined) {
            let dependentOnOff = $(dependentOnCheckboxOff);
            section.showAnimatedIf(!dependentOnOff.is(':checked'), animateType);

            dependentOnOff.change(function () {
                section.showAnimatedIf(!dependentOnOff.is(':checked'), animateType);
            });
        }
        let dependentOnCheckboxGroup = section.attr('data-dependent-on-checkbox-group');
        if(dependentOnCheckboxGroup !== undefined) {
            let dependentSelector = $(dependentOnCheckboxGroup + ' .form-check-input');
            section.showAnimatedIf($(dependentOnCheckboxGroup + ' .form-check-input:checked').length > 0, animateType);
            dependentSelector.change(function() {
                section.showAnimatedIf($(dependentOnCheckboxGroup + ' .form-check-input:checked').length > 0, animateType);
            });
        }

        let dependentOnRadio = section.attr('data-dependant-on-radio');
        if(dependentOnRadio !== undefined) {
            let selector = $(dependentOnRadio);

            function updateState() {
                let checked = $(dependentOnRadio + ':checked').val();
                let showing = section.find('.dependent-sub-section[data-dependent-on-radio-value="'+checked+'"]');
                let hiding = section.find('.dependent-sub-section').not(showing);

                if(hiding.length > 0) {
                    hiding.showAnimatedIf(false, animateType, function() {
                        showing.showAnimatedIf(true, animateType)
                    });
                } else {
                    showing.showAnimatedIf(true, animateType);
                }
            }
            updateState();
            selector.change(updateState);
            section.show();
        }
    };
}
